
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProjectDetailsForm from '@/components/ProjectDetailsForm';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ProjectPaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  
  // Get service details from URL parameters
  const serviceType = searchParams.get('type') || '';
  const serviceTier = searchParams.get('tier') || '';
  const price = searchParams.get('price') ? parseInt(searchParams.get('price')!) : 0;

  // Redirect if required params are missing
  if (!serviceType || !serviceTier || !price) {
    React.useEffect(() => {
      navigate('/services');
    }, []);
    return null;
  }

  return (
    <main className="flex-grow px-4 py-12 bg-luxury-50">
      <div className="container mx-auto max-w-4xl">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>
        
        <div className="bg-white rounded-xl shadow-luxury p-8">
          <ProjectDetailsForm 
            serviceType={serviceType}
            serviceTier={serviceTier}
            price={price}
          />
        </div>
      </div>
    </main>
  );
};

export default ProjectPaymentPage;
